"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: "16",
    height: "16"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Zm4.1,5.31L7.4,11.84a.93.93,0,0,1-.75.38A.91.91,0,0,1,6,12L4.08,10a.91.91,0, 0,1,.71-1.55.9.9,0,0,1,.59.28L6.55,9.89l4.07-5.65a.92.92,0,0,1,.59-.36.87.87,0,0,1,.68.16.89.89,0,0,1, .37.59A.92.92,0,0,1,12.1,5.31Z"
  }));
};

exports["default"] = _default;